<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div id="order-info-in-dialog" class="order-wrap" v-if="visible">
        <div class="order-content">
          <div class="order-data">
            <div class="order-data-item">
              <div class="order-title">
                <p>
                  <span class="icon"></span>
                  來源/類型
                </p>
              </div>
              <div class="order-info order-button-wrap" style="text-align: center">
                {{ mapValue[getSource]?.label }} / {{ mapValue[getTakeAwayMethod].label }}
              </div>
            </div>
            <div class="order-data-item">
              <div class="order-title">
                <p>
                  <span class="icon"></span>
                  資訊
                </p>
                <div class="line"></div>
              </div>
              <div class="order-button-wrap">
                <div class="order-info-button">
                  <div>
                    <p>姓名：{{ orderInformation.consumer.order_user_name || '無' }}</p>
                    <p>電話：{{ orderInformation.consumer.order_user_tel || '無' }}</p>
                    <p v-if="orderInformation.consumer.outside_order_id">
                      {{ mapValue[getSource].label + '取餐號：' + orderInformation.consumer.outside_order_id }}
                    </p>
                    <p>時間：{{ orderInformation.consumer.order_take_time || '無' }}</p>
                    <p>地點：{{ orderInformation.consumer.order_user_address || '無' }}</p>
                    <p>備註：{{ orderInformation.consumer.note || '無' }}</p>
                  </div>
                  <div class="action-icon" @click="openDialog('consumer')">
                    <i data-action="edit" class="bi bi-pencil"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-footer">
            <cus-button text="返回" :width="50" color="white" style="padding-left: 0" @click="close"></cus-button>
            <cus-button
              text="儲存"
              :width="50"
              color="blue"
              style="padding-right: 0"
              :disabled="!checkChange()"
              @click="handleUpdateOrder"
            ></cus-button>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { inject, reactive, defineAsyncComponent } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { mapValue } from '@/utils/define';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'order-info-in-dialog',
  components: {
    InputInfo: defineAsyncComponent(() => import('@/components/dialog/InputInfo.vue')),
  },
  setup() {
    const visible = inject('inner_dialogVisible', false);
    const close = inject('inner_close');
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得訂單資訊
    const { getOrderInfo, getSource, getTakeAwayMethod } = useGetters('order', [
      'getOrderInfo',
      'getSource',
      'getTakeAwayMethod',
    ]);
    //處理資訊
    const orderInformation = reactive({
      source: getSource.value,
      consumer: {
        order_user_name: getOrderInfo.value.order_user_name,
        order_user_tel: getOrderInfo.value.order_user_tel,
        outside_order_id: getOrderInfo.value.outside_order_id,
        note: getOrderInfo.value.note,
        order_take_time: getOrderInfo.value.order_take_time,
        order_user_address: getOrderInfo.value.order_user_address,
      },
    });
    const checkChange = () => {
      let isChange;
      const initData = {
        order_user_name: getOrderInfo.value.order_user_name,
        order_user_tel: getOrderInfo.value.order_user_tel,
        outside_order_id: getOrderInfo.value.outside_order_id,
        note: getOrderInfo.value.note,
        order_take_time: getOrderInfo.value.order_take_time,
        order_user_address: getOrderInfo.value.order_user_address,
      };
      isChange = !(JSON.stringify(initData) === JSON.stringify(orderInformation.consumer));
      return isChange;
    };

    //處理彈窗
    const handleConsumer = (val) => {
      orderInformation.consumer = val;
      closeDialog();
    };

    //更新訂單資訊
    const doUpdateOrder = useActions('order', ['doUpdateOrder']);
    const handleUpdateOrder = async () => {
      try {
        await doUpdateOrder(orderInformation);
        close();
      } catch (e) {
        return false;
      }
    };
    return {
      mapValue,
      visible,
      close,
      getOrderInfo,
      getSource,
      getTakeAwayMethod,
      dialogTemplate,
      openDialog,
      orderInformation,
      checkChange,
      handleConsumer,
      handleUpdateOrder,
    };
  },
};
</script>
<style lang="scss" scoped>
$title-wrap: 15%;
.order {
  &-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: $color-mask;
    @include flex-center-center;
    z-index: 900;
  }
  &-content {
    width: 780px;
    display: grid;
    grid-template-rows: auto 80px;
    @include white-bg;
  }
  &-data {
    padding: 20px 20px 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &-data-item {
    display: flex;
    align-items: baseline;
    margin: 12px 0;
  }
  &-title {
    width: $title-wrap;
    color: $color-blue;
    font-size: 2rem;
    @include icon-line;
  }
  &-info {
    border-radius: 4px;
    padding: 16px;
    font-size: 2.2rem;
    border: 2px solid $color-gray-10;
    color: $color-gray-20;
  }
  &-info-button {
    position: relative;
    border-radius: 4px;
    padding: 16px;
    font-size: 2.2rem;
    background-color: $color-gray-3;
    border: 2px solid $color-gray-10;
    color: $color-gray-60;
    transition: 0.2s;
    p {
      line-height: 3.5rem;
    }
    .action-icon {
      height: fit-content;
      height: -moz-fit-content;
      top: 0;
      transform: translateY(50%);
      cursor: pointer;
    }
  }
  &-button-wrap {
    width: calc(100% - $title-wrap);
  }
  &-footer {
    padding: 10px 20px;
    display: flex;
  }
}
</style>
